module.exports = __webpack_public_path__ + "img/p4-c1-p2.8f787817.jpg";